<template>
    <a href="#" class="btn btn-outline green profile-add" aria-role="button" v-on:click.prevent="addTag" v-if="!isAdded">{{tagName}}</a>
    <div class="alert alert-success" role="alert" v-else>
       <strong>{{tagName}}</strong> has now been added to your preferences.
    </div>
</template>

<script>
    import Axios from 'axios'

    export default {
        computed: {
        },

        created: function () {
            this.init()
        },

        data() {
            return {
                isAdded: false,
                loading: true
            }
        },

        methods: {
            init: function () {
                const vm = this
                vm.loading = false,
                vm.isAdded = false
            },
            addTag: function () {
                const vm = this
                const toggleAdded = function () {
                    return Axios.get('/umbraco/api/MemberProfileApi/AddTag', { params: { currentPageId: currentPageId, tagId: vm.tagId } })
                }

                Axios.all([toggleAdded()])
                    .then(Axios.spread(function (response) {

                        if (response) {
                            vm.isAdded = response.data
                        }

                        vm.loading = false
                    }))
                    .catch(() => {
                        vm.loading = false
                    })
            }
        },

        props: {
            tagId: {
                required: true,
                type: String
            },
            tagName: {
                required: true,
                type: String
            }
        },

        watch: {
            tagId: function () {
                this.init()
            }
        }
    }
</script>
